
/* injects from baggage-loader */
require('./user-select.component.html');

import angular from 'angular';

angular.module('AaApp.Opp').component('userSelect', {
    templateUrl: '/app/components/deal-sheet/user-select.component.html',
    controller: UserSelectController,
    bindings: {
        users: '<',
        defaultUserId: '<',
        onSelect: '&'
    }
});

/* @ngInject */
function UserSelectController() {
    var $ctrl = this;

    $ctrl.selectedUser;
    $ctrl.setSelectedUser = setSelectedUser;

    function setSelectedUser(user) {
        $ctrl.selectedUser = user;

        $ctrl.onSelect({ user: user });
    }
}
